import { ErrorListItem, Grid, Stack } from '@razz-team/ui-web';
import { StandingOrderDestinations } from './StandingOrderDestinations';
import { AddStandingOrderDestination } from './AddStandingOrderDestination';
import { useStandingOrderDestinationsQuery } from '../../../api/standing-orders';
import { useAccountsQuery } from '../../../api/accounts';
import { useBeneficiariesQuery } from '../../../api/beneficiaries';
import { calculateMaxDestinationRatio } from './utils';
import { useMemo } from 'react';
import { NoMoreDestinations } from './NoMoreDestinations';
import { ApiStandingOrder } from '../../../openapi';

export function StandingOrderDestinationsStep({
  ref,
  order,
}: {
  ref?: React.Ref<HTMLDivElement>;
  order: ApiStandingOrder;
}) {
  const destinationsQuery = useStandingOrderDestinationsQuery({ orderId: order.id });
  const accountsQuery = useAccountsQuery();
  const beneficiariesQuery = useBeneficiariesQuery();

  const destinations = useMemo(
    () => destinationsQuery.data?.filter((d) => d.status !== 'TERMINATED') ?? [],
    [destinationsQuery.data],
  );

  const maxRatio = useMemo(() => calculateMaxDestinationRatio({ destinations }), [destinations]);

  if (destinationsQuery.isPending || accountsQuery.isPending || beneficiariesQuery.isPending) {
    return null;
  }

  const error = destinationsQuery.error || accountsQuery.error || beneficiariesQuery.error;
  if (error) {
    return <ErrorListItem error={error} />;
  }

  if (!(destinationsQuery.isSuccess && accountsQuery.isSuccess && beneficiariesQuery.isSuccess)) {
    return null;
  }

  return (
    <Stack ref={ref} direction={{ xs: 'column-reverse', md: 'row' }} spacing={2} width="100%">
      <Grid size={{ xs: 12, md: 6 }}>
        {maxRatio > 0 ? (
          <AddStandingOrderDestination
            order={order}
            destinations={destinations}
            accounts={accountsQuery.data}
            beneficiaries={beneficiariesQuery.data}
            maxRatio={maxRatio}
          />
        ) : (
          <NoMoreDestinations />
        )}
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <StandingOrderDestinations
          destinations={destinations}
          accounts={accountsQuery.data}
          beneficiaries={beneficiariesQuery.data}
        />
      </Grid>
    </Stack>
  );
}
